/* eslint-disable relay/unused-fields */
import { graphql } from 'react-relay/legacy';

/**
 * Added item to initial query to be able to pull
 * handlePdpStatuses_item on server to determine if we need to redirect or 404.
 * Do not add other framments to item in this query
 */

export const pdpRespRootQuery = graphql`
    query pdpRespRootQuery(
        $isClient: Boolean!
        $afterDisplay: Boolean!
        $itemId: String!
        $itemIds: [String]!
        $userId: String = ""
        $userIds: [String]
        $fetchUser: Boolean!
        $followSearchPages: [String]
        $followSearchTypes: [types] = [SEARCH, USER_PREFERENCE]
        $isTrade: Boolean!
        $isMultiSku: Boolean!
        $fetchPdp: Boolean!
        $forcedCurrency: Currency
        $userZipCode: String = ""
        $userCountryCode: String = ""
        $fetchRegionalInfo: Boolean = false
        $priceBookName: String = ""
        $isInteractivePdpChat: Boolean = false
        $timezoneOffset: Int
        $fetchAuction: Boolean = false
        $itemQuantity: Int
        $isTopYmalVariant: Boolean = false
        $fdfQuoteABTestVariant: String
    ) {
        viewer {
            ...PdpRespLayout_viewer
            itemRead(itemIds: $itemIds) {
                ... on Item {
                    isFurniture
                    isAuctionEnabled
                    ...handlePdpStatuses_item
                }
                ...findPdpItemReadError_itemRead
            }
        }
    }
`;

export const pdpRespVariables = {
    isClient: false,
    afterDisplay: false,
    itemId: null,
    itemIds: [],
    selectedItemIds: [],
    userId: '',
    userIds: [],
    fetchUser: false,
    loadPortfolioData: false,
    followSearchPages: null,
    isTrade: false,
    isMultiSku: false,
    fetchPdp: true,
    forcedCurrency: null,
    fdfQuoteABTestVariant: '',
};
